<div class="flex flex-row">
  <div class="flex flex-50p left-part">
    <ng-content select="[left]"></ng-content>
  </div>
  <div class="divider"></div>
  <div class="flex flex-50p right-part">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
